import { render, staticRenderFns } from "./financeiro-tabela-preco.vue?vue&type=template&id=4771d273&scoped=true"
import script from "./financeiro-tabela-preco.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-preco.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-preco.vue?vue&type=style&index=0&id=4771d273&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771d273",
  null
  
)

export default component.exports